import React, { Component } from 'react';
import LogoWhite from './../../logo-proximus-white.png';
import Logo from './../../logo-proximus.png';
import LogoTrans from './../../smallpxslogo.png';

export class Success extends Component {

    constructor() {
        super();


    }

    render() {
        return(
            <div className="gradient" style={this.props.getBackground()}>
                <div id="previewHeader">
                    <section>
                        <div>
                            <a className="icon nav-left"></a>
                            { this.props.showTitle()
                                ? <p className="serviceName">{this.props.fieldValues.serviceName}</p>
                                : ''
                            }
                        </div>

                        <h2>{this.props.showMessage('message_16_01')}</h2>

                        <p>{this.props.showMessage('message_16_02')}</p>
                    </section>
                </div>
                <section id="content-section">
                    <div>
                        <h1 className="purple" style={{paddingTop: '10px'}}>{this.props.showMessage('message_16_03')}</h1>
                    </div>
                    <div className="infoPanel">
                        <p style={{textAlign: 'left'}}>{this.props.showMessage('message_16_04')}</p>
                    </div>
                    <div>
                        <h1 className="purple" id="countDown">00:07:23</h1>
                    </div>
                    <div id="social-links-container">
                        <i className="icon-facebook-circle-border" style={{display: this.props.displayFacebook()}} />
                        <i className="icon-foursquare-circle-border" style={{display: this.props.displayFoursquare()}} />
                        <i className="icon-twitter-circle-border" style={{display: this.props.displayTwitter()}} />
                    </div>
                    <div>
                        <p style={{textAlign: 'right', marginTop: '50px', marginBottom: '15px'}}>{this.props.showMessage('message_16_05')} <img src={LogoTrans} style={{maxWidth: '90px', verticalAlign: 'middle'}} /></p>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/preview/Success.jsx